import Loadable from "react-loadable";

export const AddPortfolioItemModal = Loadable({
  loader: () => import("../../../modules/manage-portfolio").then((module) => module.AddPortfolioItemModal) as Promise<any>,
  loading: () => null,
});
